import _sfc_main from "./index.vue2.mjs";
/* empty css            */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "playRegionDomRef", staticClass: "stream-play-container", attrs: { "id": _setup.playRegionDomId } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d6937b63"
);
const StreamPlay = __component__.exports;
export {
  StreamPlay as default
};
